/**
 * Bank Entity Service - Portfolio Management
 *
 * Handles active loan portfolio management including:
 * - Loan servicing
 * - Payment tracking
 * - Performance monitoring
 * - Portfolio analytics
 */

// ====== PORTFOLIO SERVICE ======

class BankPortfolioService {
  private baseUrl = '/api/bank/portfolio';
  private useMockApi = import.meta.env.VITE_USE_MOCK_API === 'true';
  private isDevelopment = import.meta.env.DEV || import.meta.env.NODE_ENV === 'development';

  /**
   * Get active loans
   */
  async getActiveLoans(): Promise<unknown[]> {
    if (this.useMockApi || this.isDevelopment) {
      return this.getMockActiveLoans();
    }

    try {
      const response = await fetch(`${this.baseUrl}/active`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        console.warn('Portfolio API not available, using mock data');
        return this.getMockActiveLoans();
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching active loans:', error);
      return this.getMockActiveLoans();
    }
  }

  private getMockActiveLoans(): unknown[] {
    return [
      {
        id: 'loan-001',
        communityName: 'Sunset Gardens',
        amount: 300000,
        balance: 285000,
        interestRate: 4.25,
        nextPayment: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000),
        status: 'current',
      },
    ];
  }
}

export const bankPortfolioService = new BankPortfolioService();
